/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAttributeDataSourcePathParams = NonNullable<
  operations['postAttributeDataSource']['parameters']['path']
>;

export type PostAttributeDataSourceRequestBody = OperationRequestBodyContent<operations['postAttributeDataSource']>;

export interface Input extends PostAttributeDataSourcePathParams {
  apiVersion?: string;
  body: PostAttributeDataSourceRequestBody;
}

export async function postAttributeDataSource(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projKey}/attribute-data-sources', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
